"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  clinicianListConfig: true,
  patientListConfig: true,
  clinicianPayerContractListConfig: true,
  payerClinicianPayerContractListConfig: true,
  payerContractListConfig: true,
  patientSubscriptionsList: true,
  patientTransactionList: true,
  adminListConfig: true,
  clinicianReviewListConfig: true,
  groupReviewListConfig: true,
  reviewListConfig: true,
  patientNotificationListForAdminView: true,
  clinicianNotificationListForAdminView: true
};
Object.defineProperty(exports, "adminListConfig", {
  enumerable: true,
  get: function get() {
    return _adminList.default;
  }
});
Object.defineProperty(exports, "clinicianListConfig", {
  enumerable: true,
  get: function get() {
    return _clinicianList.default;
  }
});
Object.defineProperty(exports, "clinicianNotificationListForAdminView", {
  enumerable: true,
  get: function get() {
    return _clinicianNotificationListForAdminView.default;
  }
});
Object.defineProperty(exports, "clinicianPayerContractListConfig", {
  enumerable: true,
  get: function get() {
    return _clinicianPayerContractList.default;
  }
});
Object.defineProperty(exports, "clinicianReviewListConfig", {
  enumerable: true,
  get: function get() {
    return _clinicianReviewList.default;
  }
});
Object.defineProperty(exports, "groupReviewListConfig", {
  enumerable: true,
  get: function get() {
    return _groupReviewList.default;
  }
});
Object.defineProperty(exports, "patientListConfig", {
  enumerable: true,
  get: function get() {
    return _patientList.default;
  }
});
Object.defineProperty(exports, "patientNotificationListForAdminView", {
  enumerable: true,
  get: function get() {
    return _patientNotificationListForAdminView.default;
  }
});
Object.defineProperty(exports, "patientSubscriptionsList", {
  enumerable: true,
  get: function get() {
    return _patientSubscriptionsList.default;
  }
});
Object.defineProperty(exports, "patientTransactionList", {
  enumerable: true,
  get: function get() {
    return _patientTransactionList.default;
  }
});
Object.defineProperty(exports, "payerClinicianPayerContractListConfig", {
  enumerable: true,
  get: function get() {
    return _payerClinicianPayerContractList.default;
  }
});
Object.defineProperty(exports, "payerContractListConfig", {
  enumerable: true,
  get: function get() {
    return _payerContractList.default;
  }
});
Object.defineProperty(exports, "reviewListConfig", {
  enumerable: true,
  get: function get() {
    return _reviewList.default;
  }
});
var _clinicianList = _interopRequireDefault(require("./clinicianList.config"));
var _patientList = _interopRequireDefault(require("./patientList.config"));
var _clinicianPayerContractList = _interopRequireDefault(require("./clinicianPayerContractList.config"));
var _payerClinicianPayerContractList = _interopRequireDefault(require("./payerClinicianPayerContractList.config"));
var _payerContractList = _interopRequireDefault(require("./payerContractList.config"));
var _patientSubscriptionsList = _interopRequireDefault(require("./patientSubscriptionsList.config"));
var _patientTransactionList = _interopRequireDefault(require("./patientTransactionList.config"));
var _adminList = _interopRequireDefault(require("./adminList.config"));
var _clinicianReviewList = _interopRequireDefault(require("./clinicianReviewList.config"));
var _groupReviewList = _interopRequireDefault(require("./groupReviewList.config"));
var _reviewList = _interopRequireDefault(require("./reviewList.config"));
var _patientNotificationListForAdminView = _interopRequireDefault(require("./patientNotificationListForAdminView.config"));
var _clinicianNotificationListForAdminView = _interopRequireDefault(require("./clinicianNotificationListForAdminView.config"));
var _shared = require("./shared");
Object.keys(_shared).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shared[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shared[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }